var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrap",staticClass:"infinite-scroll-wrap"},[_vm._t("default",null,{"items":_vm.items,"modelIds":_vm.modelIds,"isLoading":_vm.isLoading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }